import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { LoginService } from 'src/app/shared/services/login.service';

@Component({
  selector: 'app-altera-senha',
  templateUrl: './altera-senha.component.html',
  styleUrls: ['alterar-senha.component.scss'],
})
export class AlteraSenhaComponent extends BaseListComponent<any> implements OnInit {
  
  loginForm: any = {
    current: '',
    new: '',
    new_confirm: '',
  };

  invalido: string;

  constructor(
    public activatedRoute: ActivatedRoute,
    private loginService: LoginService,
  ) {
    super()
  }

  public ngOnInit(): void {
    this.invalido = "";
    this.loaded()
  }
  
  aterarSenha(){
    
    if (this.loginForm.current.toString().trim().length == 0) {
      this.invalido = "Erro: Por segurança, digite a senha atual.";
      return;
    }
    if (this.loginForm.new.toString().trim().length == 0) {
      this.invalido = "Erro: Por favor, digite a nova senha.";
      return;
    }
    if (this.loginForm.new_confirm.toString().trim().length == 0) {
      this.invalido = "Erro: Por segurança, digite a confirmação de senha.";
      return;
    }

    this.loginService.updateAlterarSenha(this.loginForm).subscribe({
      next: (value) => {
        this.loaded()
        this.msgSuccess(value);
      },
      error: (err) => {
        this.loaded()
        this.msgError(typeof err.error !== 'object' ? err.error : err.message);
      },
    })    
    
  }
}
